export class Tabs {
  /**
     *
     * @param classNames
     * @param config
     *
     * configuration object include:
     *
     *      speed: [(Integer), (Integer)];
     *      first value - for hide, second - for show
     *      default values: [0, 0]
     *
     *
     *      animation: [(String), String]
     *      first value - for hide, second - for show
     *      default values: [hide, fadeIn]
     *
     */

  constructor(classNames = {}, config = {}) {
    /* Config */

    this.config = {
      speed: config.speed || [0, 0],
      animation: config.animation || ['hide', 'fadeIn'], // ['slideUp','slideDown']
    };

    this.$tabs = $(`.${classNames.initTabs}`);

    /* ClassNames */
    this.tabs = classNames.initTabs;
    this.tabsContent = classNames.tab;
    this.tabsContentActive = classNames.tabActive;
    this.tabsLink = classNames.tabLink;
    this.tabsLinkActive = classNames.tabLinkActive;

    this.bindEvents();
  }

  bindEvents() {
    $(`.${this.tabsLink}`).on('touchstart click', (e) => {
      const $clickedLink = $(e.currentTarget);
      e.preventDefault();
      this.toggleTab($clickedLink, $clickedLink.data('tab'));
    });
  }

  /**
     * This method sets the value of active tab from any place
     *
     * @param contentName - string, name of tab to set
     */
  setActiveTab(contentName) {
    this.$tabs.find(`.${this.tabsContent}._active`).hide().removeClass(this.tabsContentActive);
    this.showContent(this.$tabs.find(`.${this.tabsContent}[data-tab="${contentName}"]`), this.config.animation[1]);
  }

  toggleTab($clickedLink, dataTab) {
    const $tabs = $clickedLink.closest(`.${this.tabs}`);
    const dataContentName = dataTab || $clickedLink.data('tab');
    const $content = $tabs.find(`.${this.tabsContent}[data-tab='${dataContentName}']`);
    const $allContents = $tabs.find(`.${this.tabsContentActive}`);

    this.hideContent($allContents, this.config.animation[0], () => {
      $allContents.removeClass(this.tabsContentActive);
      $clickedLink.closest(`.${this.tabs}`).find(`.${this.tabsLink}`).removeClass(this.tabsLinkActive);
      $clickedLink.addClass(this.tabsLinkActive);

      this.showContent($content, this.config.animation[1]);
    });
  }

  showContent($selector, animation) {
    if (animation === 'slideDown') {
      $selector.slideDown(this.config.speed[1], () => $selector.addClass(this.tabsContentActive));
      return;
    }
    $selector.addClass(this.tabsContentActive).fadeIn(this.config.speed[1]);
  }

  hideContent($selector, animation, callback) {
    if (animation === 'slideUp') {
      $selector.slideUp(this.config.speed[0], callback);
      return;
    }
    $selector.fadeOut(this.config.speed[0], callback);
  }
}

/**
 * Init object for ModalAccount with unique properties
 * @type {Tabs}
 */
const modalAccountTabs = new Tabs(
  {
    initTabs: 'modal-account__container',
    tab: 'modal-account__content',
    tabActive: '_active',
    tabLink: 'modal-account__btn-js',
    tabLinkActive: '_active-link',
  },
  {
    speed: [300, 300],
  },
);

export { modalAccountTabs };
